import { Grid } from '@material-ui/core'
import { FunctionComponent } from 'react'
import { HiOutlineEye } from 'react-icons/hi'
import { colors } from 'shared/styles/colors'
import { Container, Subtitle, Title } from './styles'

interface IProps {
  title: string
  subtitle?: string
  onClick: any
}

const DocumentoAnexado: FunctionComponent<IProps> = ({
  title,
  subtitle,
  onClick,
}) => {
  return (
    <Container>
      <Grid container alignItems="center" md={12} xs={8}>
        <Grid item xs={12} md={6}>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </Grid>
        <Grid
          container
          xs={12}
          md={6}
          justifyContent="flex-end"
          style={{ paddingRight: 10 }}
        >
          <HiOutlineEye
            onClick={onClick}
            size={24}
            color={colors.black}
            style={{ cursor: 'pointer' }}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

export default DocumentoAnexado
